// extracted by mini-css-extract-plugin
export default {"h3":"estilos_h3__TlLYP","span":"estilos_span__DlL6S"};